// DKM-5192 Cedric: eski hâli
// import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DxButtonModule, DxPopupModule, DxToolbarModule} from "devextreme-angular";
import {PositionAlignment} from "devextreme/common";
import {FormDto} from "../../models/ortak.dtos";
import {PopupFooterComponent} from "../footers/popup-footer/popup-footer.component";
import {DxiItemModule} from "devextreme-angular/ui/nested";
import {AuthService} from "../../../../../../auth/src/lib/auth.service";
import {LoadingService} from '../../services/loading.service';
import {PopupHeaderComponent} from '../headers/popup-header/popup-header.component';
import { DynamicButton } from '../../constants';

@Component({
  selector: 'dk-form-popup',
  standalone: true,
  imports: [CommonModule, DxPopupModule, DxButtonModule, PopupFooterComponent, DxToolbarModule, DxiItemModule, PopupHeaderComponent],
  templateUrl: './dk-form-popup.component.html',
  styleUrls: ['./dk-form-popup.component.scss'],
})
// DKM-5192 Cedric: eski hâli
// export class DkFormPopupComponent implements OnInit {
export class DkFormPopupComponent implements OnInit, OnChanges {
  @Input() visible: boolean = false;
  /**
   * DKM-5192: "Düzenle" düğmesiz popup (opt-in, varsayılan kapalı → mevcut ekranlar değişmez).
   * true verilirse başlıktaki Düzenle düğmesi hiç gösterilmez; state 'Edit' iken popup
   * güncelleme yetkisine göre açılır: formYetki.updateYn (ya da admin) → doğrudan düzenleme kipi
   * (editModeChange(true)); yetki yoksa editModeChange(false) → yansıtılan form salt okunur, Kaydet pasif
   * (formlardaki `!editMode && state !== 'New'` deseni). formMetada sonradan gelirse ngOnChanges yeniden hesaplar.
   */
  @Input() otomatikDuzenle = false;
  @Input() title: string = '';
  @Input() popupName: string = '';
  @Input() isShowCancelButton = true;
  @Input() displayEditBtn = true;
  @Input() state: string;
  @Input() width: any;
  @Input() formMetada!: FormDto;
  @Input() height: any;
  @Input() animation!: any;
  @Input() errorResponse: string[];
  @Input() position: PositionAlignment = 'center';
  @Input() dynamicButtons: DynamicButton[] = [];
  @Input() maximizable = false;
  isFullScreen = false;
  @Output() dynamicButtonClicked = new EventEmitter<DynamicButton>();
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() editModeChange = new EventEmitter<boolean>();
  isAdmin = false
  editmode: boolean = false;
  // viewButtonOptions = {s
  //   hint: 'View',
  //   icon: 'eyeopen',
  //   stylingMode: 'outlined',
  //   onClick: () => {
  //     this.toggleEdit()
  //   },
  //
  // };

  toolbarItems = [
    {
      toolbar: 'bottom',
      location: 'after',
      template: 'bottom'
    }
  ]

  constructor(private authService: AuthService,
              private loadingService: LoadingService
  ) {
  }

  ngOnChanges(changes: SimpleChanges) {
    // DKM-5192: otomatikDuzenle açıkken Edit kipini yetkiye göre belirle (ilk açılış + state/formMetada/visible değişimi)
    if (this.otomatikDuzenle && (changes['state'] || changes['formMetada'] || changes['visible'] || changes['otomatikDuzenle'])) {
      this.otomatikDuzenleUygula();
    }
  }

  ngOnInit() {
    this.isAdmin = this.authService.isUserAdmin()
    // DKM-5192 Cedric: eski hâli
    // if (!this.displayEditBtn && this.state === 'Edit') {
    if (!this.otomatikDuzenle && !this.displayEditBtn && this.state === 'Edit') {
      this.editmode = true;
      this.editModeChange.emit(true)
    }
  }

  /** DKM-5192: başlıkta Düzenle düğmesi gösterilsin mi (otomatikDuzenle açıkken asla). */
  get duzenleDugmesiGorunur(): boolean {
    return this.displayEditBtn && !this.otomatikDuzenle;
  }

  /** DKM-5192: güncelleme yetkisi — formYetki.updateYn ya da admin. */
  private guncellemeYetkisiVar(): boolean {
    return !!this.formMetada?.formYetki?.updateYn || !!this.authService.isUserAdmin();
  }

  private otomatikDuzenleUygula() {
    if (this.state !== 'Edit' || !this.visible) return;
    const yetki = this.guncellemeYetkisiVar();
    this.editmode = yetki;
    this.editModeChange.emit(yetki);
  }

  onHiding() {
    this.visible = false
    this.isFullScreen = false
    this.visibleChange.emit(false);
    // DKM-5192 Cedric: eski hâli
    // if (this.displayEditBtn) {
    //   this.editModeChange.emit(this.editmode)
    // }
    if (this.otomatikDuzenle) {
      // kapanınca kip sıfırlanır; tekrar açılışta (ngIf'siz popup'ta visible değişimiyle) yetkiye göre yeniden açılır
      this.editmode = false;
      this.editModeChange.emit(false);
    } else if (this.displayEditBtn) {
      this.editModeChange.emit(this.editmode)
    }
  }

  ngOnDestroy() {
    this.loadingService.hideLoading();
  }


  handleCancelClick() {

  }

  handleSaveClick() {

  }
}
